import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
        justifyContent: "space-evenly",
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3),
		"& > * + *": {
			marginLeft: theme.spacing(2),
		},
	},
}));

export default function Loader() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CircularProgress />
		</div>
	);
}
